module.exports = __webpack_public_path__ + "static/media/shaff1199.57da0e04.jpg";